"use client";
import SectionPage from "@/components/common/section-page";
import {PageNotFound} from "@/components/common/page-en-construction";
import HeaderSiteOfficiel from "@/components/site-officiel/header-site-officiel";
import FooterSiteOfficiel from "@/components/site-officiel/footer-site-officiel";

export default function Home() {

  return (

      <main>
          <HeaderSiteOfficiel />
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>
              {/* Nature & Biodiversité */}
              <SectionPage sectionType="lg">
                  <PageNotFound />
              </SectionPage>

          </div>
          <FooterSiteOfficiel />
      </main>
  );
}
